export default __webpack_public_path__ + "b0af8000f28f2f38e1cc6fed7648a655.svg";